/** Catalog folder names under `assets/vc-<name>/i18n/` (merged at runtime). */
export const TRANSLATION_CATALOG_APPS = [
    'admin-ui',
    'assessment-ui',
    'assets-ui',
    'core-ui',
    'endpoint-ui',
    'events-ui',
    'file-browser-ui',
    'findings-ui',
    'login-ui',
    'marketplace-ui',
    'mss-ui',
    'scan-ui',
    'security-operation-ui',
    'core-lib',
] as const;
